"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var service_service_1 = require("./../../../Services/service.service");
var subscribtion_service_1 = require("./../../../Services/subscribtion.service");
var core_1 = require("@angular/core");
var AdView;
(function (AdView) {
    AdView[AdView["Advertisement"] = 0] = "Advertisement";
    AdView[AdView["Payment"] = 1] = "Payment";
})(AdView = exports.AdView || (exports.AdView = {}));
var MobileBuyThirdPartyComponent = /** @class */ (function () {
    function MobileBuyThirdPartyComponent(services, subscriptionService) {
        this.services = services;
        this.subscriptionService = subscriptionService;
    }
    MobileBuyThirdPartyComponent.prototype.ngOnInit = function () {
    };
    return MobileBuyThirdPartyComponent;
}());
exports.MobileBuyThirdPartyComponent = MobileBuyThirdPartyComponent;
